import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { commonSelectSx } from 'styles/muiStyles';

export interface BaseProvider {
  id: number | string;
  name: string;
  displayName?: string;
}

interface ProviderSelectProps {
  providers: BaseProvider[];
  selectedProviderId: string | number;
  onChange: (providerId: string | number) => void;
  className?: string;
  label?: string;
  disabled?: boolean;
  sx?: any;
}

const ProviderSelect: React.FC<ProviderSelectProps> = ({
  providers,
  selectedProviderId,
  onChange,
  className = '',
  label = 'Provider',
  disabled = false,
  sx = {},
}) => {
  return (
    <FormControl fullWidth size="small" className={className}>
      <InputLabel
        sx={{
          color: '#8698a6',
          '&.Mui-focused': {
            color: '#8698a6',
          },
        }}
      >
        {label}
      </InputLabel>
      <Select
        value={selectedProviderId}
        label={label}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        sx={{
          ...commonSelectSx,
          ...sx,
        }}
        MenuProps={{
          PaperProps: {
            style: { maxHeight: 300 },
          },
        }}
      >
        {providers.map((p) => (
          <MenuItem key={p.id} value={p.id}>
            {p.displayName || p.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ProviderSelect;
